export default function menu() {

    /*   function insertAfter(newElement, referenceElement) {
           referenceElement.parentNode.insertBefore(newElement, referenceElement.nextSibling);
       }

       let navigation = document.querySelector('.navigation'),
       hiding = document.querySelector('.hiding'),
       contacts = document.querySelector('.contacts');

       hiding.style.top = navigation.offsetHeight + "px";
       contacts.style.top = navigation.offsetHeight + "px";

       window.addEventListener('resize', function () {
           let navigation = document.querySelector('.navigation'),
               hiding = document.querySelector('.hiding'),
               contacts = document.querySelector('.contacts');

           hiding.style.top = navigation.offsetHeight + "px";
           contacts.style.top = navigation.offsetHeight + "px";
       })


       navigation.querySelectorAll('li.menu-item-has-children').forEach(item => {
           item.addEventListener('mouseover', (e) => {
               hiding.classList.add('hiding--active');
           });
           item.addEventListener('mouseleave', (e) => {
               hiding.classList.remove('hiding--active');
           });
       })*/


    /*  let burger = document.querySelector('.menu-toggle'),
          menu_container = document.querySelector('.header__menu'),
          body = document.querySelector('body'),
          burger_status = false;

      burger.addEventListener('click', (e) => {
          e.preventDefault();
          if (!burger.classList.contains('menu-toggle--active')) {
              burger.classList.add('menu-toggle--active');
              burger_status = true;
          } else {
              burger.classList.remove('menu-toggle--active')
              burger_status = false;
          }
          if (burger_status) {
              menu_container.classList.add('header__menu--active')
              body.classList.add('overflow-h');
          } else {
              menu_container.classList.remove('header__menu--active')
              body.classList.remove('overflow-h');
          }
      })

      let menu = document.querySelector('.main-menu');

      document.querySelectorAll('.toggler')
          .forEach(toggler => {
              toggler.addEventListener('click', (e) => {
                  e.preventDefault();
                  let parent = toggler.closest('.menu-item-has-children');
                  if (!parent.classList.contains('active')) {
                      parent.classList.add('active');
                  } else {
                      parent.classList.remove('active')
                  }

              })
          })
  */

    // desktop menu
/*    let button__menu = document.querySelector('.toggle-services'),
        button_mob__menu = document.querySelector('.toggle-menu'),
        desktop_menu = document.querySelector('.header-navigation-services'),
        mob_menu = document.querySelector('.header-navigation'),
        body = document.querySelector('body'),
        shroud = document.querySelector('.shroud'),
        desktop_menu_status = false,
        mob_menu_status = false;

    shroud.addEventListener('click', (e) => {
        e.preventDefault();
        if (body.classList.contains('pseudo')) {
            body.classList.remove('pseudo');
        }

        if (button__menu.classList.contains('toggle-services--active')) {
            button__menu.classList.remove('toggle-services--active');
        }

        desktop_menu.classList.remove('header-navigation-services--active');
    });

    button__menu.addEventListener('click', (e) => {
        e.preventDefault();
        if (!button__menu.classList.contains('toggle-services--active')) {
            button__menu.classList.add('toggle-services--active');
            desktop_menu_status = true;
        } else {
            button__menu.classList.remove('toggle-services--active')
            desktop_menu_status = false;
        }
        if (desktop_menu_status) {
            desktop_menu.classList.add('header-navigation-services--active');
            body.classList.add('pseudo');
        } else {
            desktop_menu.classList.remove('header-navigation-services--active');
            body.classList.remove('pseudo');
        }
    })

    // mob menu
    button_mob__menu.addEventListener('click', (e) => {
        e.preventDefault();
        if (!button_mob__menu.classList.contains('toggle-menu--active')) {
            button_mob__menu.classList.add('toggle-menu--active');
            mob_menu_status = true;
        } else {
            button_mob__menu.classList.remove('toggle-menu--active')
            mob_menu_status = false;
        }

        if (mob_menu_status) {
            mob_menu.classList.add('header-navigation--active');
            body.classList.add('pseudo');
        } else {
            mob_menu.classList.remove('header-navigation--active');
            body.classList.remove('pseudo');
        }
    })


    let header_menu_services_li = document.querySelectorAll('.header-menu-services > li.menu-item-depth-0');
    if(header_menu_services_li.item(0)){
        header_menu_services_li.item(0).classList.add('active');
    }
    header_menu_services_li.forEach(li => {
        li.addEventListener('mouseover', (e) => {
            e.preventDefault();
            li.classList.add('active');
            header_menu_services_li.forEach(li_ => {
                e.preventDefault();
                if(li !== li_){
                    li_.classList.remove('active');
                }
            })
        })
    })*/

    let burger = document.querySelector('.menu-toggle'),
        menu_container = document.querySelector('.header__navigation'),
        body = document.querySelector('body'),
        burger_status = false;

    burger.addEventListener('click', (e) => {
        e.preventDefault();
        if (!burger.classList.contains('menu-toggle--active')) {
            burger.classList.add('menu-toggle--active');
            burger_status = true;
        } else {
            burger.classList.remove('menu-toggle--active')
            burger_status = false;
        }
        if (burger_status) {
            menu_container.classList.add('header__navigation--active')
            body.classList.add('overflow-h');
        } else {
            menu_container.classList.remove('header__navigation--active')
            body.classList.remove('overflow-h');
        }
    })

    let menu = document.querySelector('.main-menu');

    document.querySelectorAll('.toggler')
        .forEach(toggler => {
            toggler.addEventListener('click', (e) => {
                e.preventDefault();
                let parent = toggler.closest('.menu-item-has-children');
                if (!parent.classList.contains('active')) {
                    parent.classList.add('active');
                } else {
                    parent.classList.remove('active')
                }

            })
        })

}